export default {
  title: 'ยานพาหนะของฉัน',
  no_vehicles: 'ไม่มียานพาหนะที่ลงทะเบียน',
  no_vehicles_sub: 'ยานพาหนะที่ลงทะเบียนไว้จะแสดงที่นี่',
  vehicle_types: {
    car: 'รถยนต์',
    motorcycle: 'รถจักรยานยนต์',
    bicycle: 'รถจักรยาน',
    other: 'อื่นๆ',
  },
  labels: {
    license_plate: 'ทะเบียนรถ',
    brand_model: 'ยี่ห้อ / รุ่น',
    color: 'สี',
    active_permits: 'สิทธิ์จอดรถที่ใช้งานอยู่',
    no_active_permits: 'ไม่มีสิทธิ์จอดรถที่ใช้งานอยู่',
    permit_type: 'ประเภท',
    zone: 'โซน',
    slot: 'ช่องจอด',
    sticker: 'สติ๊กเกอร์',
    valid_until: 'ใช้ได้ถึง',
    monthly_fee: 'ค่าจอดรายเดือน',
    daily_fee: 'ค่าจอดรายวัน',
    last_seen: 'พบล่าสุด',
  },
  permit_types: {
    tenant_included: 'รวมในสัญญา',
    tenant_addon: 'เพิ่มเติม',
    monthly_external: 'รายเดือน',
    daily_external: 'รายวัน',
  },
  lpr: {
    recent_events_title: 'ประวัติกล้องจดจำป้ายล่าสุด',
    show_events: 'แสดงรายการ',
    hide_events: 'ซ่อนรายการ',
    n_more: 'อีก {{count}} รายการ',
    view_all: 'ดูทั้งหมด',
    direction_in: 'เข้า',
    direction_out: 'ออก',
    direction_unknown: 'ไม่ระบุ',
    no_events: 'ไม่มีประวัติกล้องล่าสุด',
    status: {
      verified_success: 'ยืนยันแล้ว',
      verified_failed: 'ไม่ตรงกัน',
      pending: 'รอดำเนินการ',
    },
  },
}
